import { FC, useEffect, useState } from 'react';

import { NavigationItem } from '@telialt/models/src/Navigation';
import { TeliaSegment, useSegment } from '@telialt/utils/src/segment';
import { useUserDataQueryBase } from '@telialt/utils/src/SSO/useUserData';

import { MobileMenuItemLink } from '../MobileMenu/MobileMenuItemLink';
import { MobileMenuItemComponentB2b } from './MobileMenuItemComponentB2b';
import { MobileMenuItemComponentDocuments } from './MobileMenuItemComponentDocuments';
import { MobileMenuItemComponentSkeleton } from './MobileMenuItemComponentSkeleton';

type Props = {
    item: NavigationItem;
    menuLevel: number;
};

export const MobileMenuItemComponentStrong: FC<Props> = ({ item, menuLevel }) => {
    const [isMounted, setIsMounted] = useState(false);
    const segment = useSegment();
    const { userData, isLoadingUserData } = useUserDataQueryBase({
        isEnabled: isMounted,
    });

    useEffect(() => {
        setIsMounted(true);
    }, []);

    if (isLoadingUserData) {
        return <MobileMenuItemComponentSkeleton />;
    }

    if (!userData?.isStrong) {
        return null;
    }

    if (segment === TeliaSegment.B2b) {
        return <MobileMenuItemComponentB2b item={item} menuLevel={menuLevel} />;
    }

    if (item.component === 'SS_DOCUMENTS') {
        return <MobileMenuItemComponentDocuments item={item} menuLevel={menuLevel} />;
    }

    return <MobileMenuItemLink item={item} menuLevel={menuLevel} />;
};
